export default "__VITE_ASSET__6404ebe7__"